
import { Component, Vue } from 'vue-property-decorator';

interface FAQ {
  question: string;
  answer: string;
}

@Component({
  components: {}
})
export default class Help extends Vue {
  protected faq: FAQ[] = [
    {
      question: this.$i18n.t('home.Help.q1').toString(),
      answer: this.$i18n.t('home.Help.a1').toString()
    },
    {
      question: this.$i18n.t('home.Help.q2').toString(),
      answer: this.$i18n.t('home.Help.a2').toString()
    }
  ];
}
